import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const DashboardApi = createApi({
    reducerPath: "DashboardApi",
    baseQuery: fetchBaseQuery({
        baseUrl: import.meta.env.VITE_API_URL + "/dashboard",
        credentials: 'include',
        prepareHeaders: (headers) => {
            const token = localStorage.getItem('_at') || null;
            if (token) {
                headers.set("Authorization", "Bearer " + token);
            }
            return headers;
        }
    }),
    tagTypes: ['Dashboard'],
    endpoints: (builder) => ({
        financeTrend: builder.query({
            query: ({ from = '', to = '' } = {}) => {
                const params = new URLSearchParams();
                if (from) params.append('from', from);
                if (to) params.append('to', to);
                const queryString = params.toString();
                return `/finance-trend${queryString ? `?${queryString}` : ''}`;
            },
            providesTags: ['Dashboard']
        }),
        inventoryValue: builder.query({
            query: () => `/inventory-value`,
            providesTags: ['Dashboard']
        }),
        lowStock: builder.query({
            query: ({ threshold = 5 } = {}) => `/low-stock?threshold=${threshold}`,
            providesTags: ['Dashboard']
        }),
        deadStock: builder.query({
            query: ({ days = 30 } = {}) => `/dead-stock?days=${days}`,
            providesTags: ['Dashboard']
        }),
    })
});

export const {
    useFinanceTrendQuery,
    useInventoryValueQuery,
    useLowStockQuery,
    useDeadStockQuery
} = DashboardApi;
